export default "__VITE_ASSET__ff65a993__"